export const graphqlEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT
export const graphqlAuth = process.env.REACT_APP_GRAPHQL_TOKEN
export const tokenAddress = process.env.REACT_APP_CONTRACT_ADDRESS
export const faqLink = 'https://hackmd.io/@DeFire/DeFireFAQ'
export const lmLink =
  'https://razer.occam.fi/liquidity-mining/0xc401fc2f36e7e87e1ab3b417442c59034e399053'
